import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from './ButtonBase';
import buttonPropTypes, { textAndA11yText } from './propTypes';
import { a11yProps, hrefAttrsProp, linkProps, contentfulProps } from '../utils/props';
import { useThemeTokensCallback } from '../ThemeProvider';
import { useViewport } from '../ViewportProvider';

/**
 * `ButtonLink` is a component with the semantics and behaviour of a link, but with the visual appearance of a button.
 * ButtonLink is a block-level component and should not be used inline.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonLink = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    accessibilityRole = 'link',
    tokens,
    variant,
    dataSet,
    ...props
  } = _ref;
  const {
    hrefAttrs,
    rest
  } = hrefAttrsProp.bundle(props);
  const viewport = useViewport();
  const buttonVariant = {
    viewport,
    ...variant
  };
  const getTokens = useThemeTokensCallback('Button', tokens, buttonVariant);
  return /*#__PURE__*/_jsx(ButtonBase, {
    ref: ref,
    accessibilityRole: accessibilityRole,
    tokens: getTokens,
    hrefAttrs: hrefAttrs,
    dataSet: dataSet,
    ...rest
  });
});
ButtonLink.displayName = 'ButtonLink';
ButtonLink.propTypes = {
  ...a11yProps.types,
  ...buttonPropTypes,
  ...linkProps.types,
  ...contentfulProps.types,
  children: textAndA11yText,
  dataSet: PropTypes.object,
  accessibilityRole: PropTypes.string
};
export default ButtonLink;